import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { addRemoveError, getControl, getGroup } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { INCORRECT_SUM, REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { toNum } from '@shared/helpers/math.helper';
import { checkRequiredFieldWithTipoBilancio, getDatiBilancioGroup } from './helpers/dati-bilancio-bis-form-validators.helper';

export const datiBilancioBisStatoPatrimonialePassivoRules: FormGroupRules = {
    my_StPaPsD11a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD11a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD3a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD3a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD4a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD4a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD4a11: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD4a11', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD4b1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD4b1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD51: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD51', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD6a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD6a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD6c1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD6c1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD7a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD7a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD8a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD8a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD9a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD9a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD10a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD10a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD12a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD12a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD13a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD13a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsTOT1: (form: FormGroup) => {
        const datiBilancioGroup = getDatiBilancioGroup(form);
        const my_StPaPsTOT1Control = getControl(datiBilancioGroup, 'my_StatoPatrimoniale__Passivo.my_StPaPsTOT1');
        const my_StPaAtTOT1: string = getControl(datiBilancioGroup, 'my_StatoPatrimoniale__Attivo.my_StPaAtTOT1')?.value;
        const my_DataApprovazione1: string = getControl(datiBilancioGroup, 'my_DataApprovazione1')?.value;
        const showError = toNum(my_StPaPsTOT1Control.value) !== toNum(my_StPaAtTOT1) && !isNilOrEmpty(my_DataApprovazione1);
        const errors = my_StPaPsTOT1Control.errors ? my_StPaPsTOT1Control.errors : {};

        addRemoveError(showError, errors, 'my_StPaPsTOT1', {
            status: 'Totali non coerenti',
        });

        my_StPaPsTOT1Control.setErrors(isEqual(errors, {}) ? null : errors);
    },
    my_StPaPsDa1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsDa1', 'my_TipoBilancioAbbr1', '1');
    },
    my_StPaPsD3a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD3a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD4a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD4a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD4a12: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD4a12', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD4b2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD4b2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD52: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD52', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD6a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD6a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD6c2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD6c2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD7a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD7a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD8a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD8a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD9a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD9a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD10a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD10a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD11a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD11a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD12a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD12a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsD13a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsD13a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaPsTOT2: (form: FormGroup) => {
        const datiBilancioGroup = getDatiBilancioGroup(form);
        const my_StPaPsTOT2Control = getControl(datiBilancioGroup, 'my_StatoPatrimoniale__Passivo.my_StPaPsTOT2');
        const my_StPaAtTOT2: string = getControl(datiBilancioGroup, 'my_StatoPatrimoniale__Attivo.my_StPaAtTOT2')?.value;
        const showError = toNum(my_StPaPsTOT2Control.value) !== toNum(my_StPaAtTOT2);
        const errors = my_StPaPsTOT2Control.errors ? my_StPaPsTOT2Control.errors : {};

        addRemoveError(showError, errors, 'my_StPaPsTOT2', {
            status: 'Totali non coerenti',
        });

        addRemoveError(isNilOrEmpty(my_StPaAtTOT2), errors, 'my_StPaPsTOT2', {
            status: REQUIRED_STATUS,
        });

        my_StPaPsTOT2Control.setErrors(isEqual(errors, {}) ? null : errors);
    },
    my_StPaPsDa2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Passivo.my_StPaPsDa2', 'my_TipoBilancioAbbr1', '1');
    },
    my_StPaPsAVIItot1: (form: FormGroup) => {
        checkAVIItot(form, '1');
    },
    my_StPaPsAVIItot2: (form: FormGroup) => {
        checkAVIItot(form, '2');
    },
    my_StPaPsAtot1: (form: FormGroup) => {
        checkStPaPsAtot(form, '1');
    },
    my_StPaPsAtot2: (form: FormGroup) => {
        checkStPaPsAtot(form, '2');
    },
};

const checkAVIItot = (form: FormGroup, suffix: '1' | '2'): void => {
    const datiBilancioGroup = getDatiBilancioGroup(form);
    const passivoGroup = getGroup(datiBilancioGroup, 'my_StatoPatrimoniale__Passivo');
    const buildName = (name: string) => `${name}${suffix}`;
    const control = getControl(passivoGroup, buildName('my_StPaPsAVIItot'));
    const my_StPaPsAVIIa = toNum(getControl(passivoGroup, buildName('my_StPaPsAVIIa'))?.value);
    const my_StPaPsAVIIb = toNum(getControl(passivoGroup, buildName('my_StPaPsAVIIb'))?.value);
    const errors = control.errors ? control.errors : {};

    addRemoveError(isNilOrEmpty(control.value), errors, buildName('my_StPaPsAVIItot'), {
        status: REQUIRED_STATUS,
    });

    addRemoveError(toNum(control.value) !== my_StPaPsAVIIa + my_StPaPsAVIIb, errors, buildName('my_StPaPsAVIItot'), {
        status: INCORRECT_SUM,
        message: `Il Totale Altre Riserve anno ${suffix} non corrisponde alla somma dei parziali.`,
    });

    control.setErrors(isEqual(errors, {}) ? null : errors);
};

const checkStPaPsAtot = (form: FormGroup, suffix: '1' | '2'): void => {
    const message = `Il totale patrimonio netto dell'anno ${suffix} non è uguale alla somma delle voci`;
    const buildName = (name: string) => `${name}${suffix}`;
    const datiBilancioGroup = getDatiBilancioGroup(form);
    const passivoGroup = getGroup(datiBilancioGroup, 'my_StatoPatrimoniale__Passivo');
    const my_StPaPsAtotControl = getControl(passivoGroup, buildName('my_StPaPsAtot'));
    const my_StPaPsAtot = toNum(my_StPaPsAtotControl?.value);
    const my_TipoSchemaBil: string = getControl(datiBilancioGroup, buildName('my_TipoSchemaBil'))?.value;
    const my_StPaPsAI = toNum(getControl(passivoGroup, buildName('my_StPaPsAI'))?.value);
    const my_StPaPsAII = toNum(getControl(passivoGroup, buildName('my_StPaPsAII'))?.value);
    const my_StPaPsAIII = toNum(getControl(passivoGroup, buildName('my_StPaPsAIII'))?.value);
    const my_StPaPsAIV = toNum(getControl(passivoGroup, buildName('my_StPaPsAIV'))?.value);
    const my_StPaPsAV = toNum(getControl(passivoGroup, buildName('my_StPaPsAV'))?.value);
    const my_StPaPsAVI = toNum(getControl(passivoGroup, buildName('my_StPaPsAVI'))?.value);
    const my_StPaPsAVIItot = toNum(getControl(passivoGroup, buildName('my_StPaPsAVIItot'))?.value);
    const my_StPaPsAVIII = toNum(getControl(passivoGroup, buildName('my_StPaPsAVIII'))?.value);
    const my_StPaPsAIX = toNum(getControl(passivoGroup, buildName('my_StPaPsAIX'))?.value);
    const my_StPaPsAVII_new = toNum(getControl(passivoGroup, buildName('my_StPaPsAVII_new'))?.value);
    const my_StPaPsAX = toNum(getControl(passivoGroup, buildName('my_StPaPsAX'))?.value);
    const errors = my_StPaPsAtotControl.errors ? my_StPaPsAtotControl.errors : {};
    const sommaComune =
        toNum(my_StPaPsAI) +
        toNum(my_StPaPsAII) +
        toNum(my_StPaPsAIII) +
        toNum(my_StPaPsAIV) +
        toNum(my_StPaPsAVI) +
        toNum(my_StPaPsAVIItot) +
        toNum(my_StPaPsAVIII) +
        toNum(my_StPaPsAIX);
    const extras = my_TipoSchemaBil === 'N' ? toNum(my_StPaPsAV) : my_StPaPsAVII_new + my_StPaPsAX;
    const totale = sommaComune + extras;

    addRemoveError(isNilOrEmpty(my_StPaPsAtot), errors, buildName('my_StPaPsAtot'), {
        status: REQUIRED_STATUS,
    });

    addRemoveError(my_StPaPsAtot !== totale, errors, buildName('my_StPaPsAtot'), {
        status: INCORRECT_SUM,
        message,
    });

    my_StPaPsAtotControl.setErrors(isEqual(errors, {}) ? null : errors);
};
